enum SurveyType {
  Survey = 'SURVEY',
  CollectId = 'COLLECT_ID',
}

export default SurveyType;
